import { getParents } from '.';
import parentLevelToIndex from './parentLevelToIndex';
import constantes from '../resources/constantes.json';
import {
  firstElectionWithAmbito,
  isAmbitoInElection,
} from '../commons/js/util';
import { getAmbitoByCode } from '../utils/nomenclatorUtils';

export const getUrlFavoritos = ({
  id, // number | string (por mesas)
  eleccion,
  nomenclator,
  page,
  idHistorico,
  parentLevel,
  c = undefined,
  mesa = undefined,
}) => {
  let idRuta = id;
  let nextPage;
  if (!page && nomenclator) {
    const eleccionDisponible = firstElectionWithAmbito(nomenclator, c);
    console.log("eleccionDisponible ",eleccionDisponible)
    if (eleccionDisponible) {
      nextPage = constantes.nombreEleccion[eleccionDisponible];
      const ambito = getAmbitoByCode(nomenclator, eleccionDisponible, c);
      idRuta = ambito.i;
    }
  } else if (c) {
    if (isAmbitoInElection(nomenclator, constantes.eleccion[page], c)) {
      nextPage = page;
    } else {
      nextPage =
        constantes.nombreEleccion[firstElectionWithAmbito(nomenclator, c)];
      const ambito = getAmbitoByCode(
        nomenclator,
        firstElectionWithAmbito(nomenclator, c),
        c
      );
      idRuta = ambito.i;
    }
  } else {
    nextPage = page;
  }
  let texto = '';
  const idStr = idRuta.toString();
  if (idStr[0] === 'm') {
    idRuta = Number(idRuta.toString().slice(7));
  }
  const isMesa = idStr[0] === 'm' || mesa;
  const genealogy = [idRuta, ...getParents(idRuta, eleccion, nomenclator, parentLevel)];
  for (const x of genealogy) {
    const ambito = nomenclator.ambitos[eleccion][x];
    texto = ambito.s.toLowerCase() + '/' + texto;
  }
  texto = texto.slice(0, -1);
  if (idRuta === 0) {
    texto = nomenclator.ambitos[eleccion][idRuta].s.toLowerCase();
  }

  const level = nomenclator.ambitos[eleccion][idRuta].l;
  const parentIndex = parentLevelToIndex(
    nomenclator,
    eleccion,
    parentLevel,
    level,
    idRuta
  );

  const parentFlag = parentIndex !== 0 ? constantes.parentFlag : '';

  if (isMesa) {
    const numeroMesa = (mesa && mesa.slice(1, 7)) || idStr.slice(1, 7);
    texto += `?mesa=${numeroMesa}`;
  }

  if (idHistorico != null) {
    return `/historico/${idHistorico}/${nextPage}/${parentFlag}${idRuta}/${texto}`;
  }
  return `/${nextPage}/${parentFlag}${idRuta}/${texto}`;
};

export default getUrlFavoritos;
